// extracted by mini-css-extract-plugin
export var dropdownButton = "_22-0";
export var fullWidthDropdownButton = "_22-1";
export var icon = "_22-3";
export var iconPlaceholder = "_22-2";
export var menuItemRow = "_22-9";
export var separator = "_22-e";
export var shortcutContainer = "_22-7";
export var shortcutContainerFilled = "_22-8";
export var shortcutIconLg = "_22-6";
export var shortcutIconMd = "_22-5";
export var shortcutIconSm = "_22-4";
export var submenuChevron = "_22-d";
export var submenuDropdown = "_22-a";
export var submenuTriggerRow = "_22-b";
export var submenuTriggerRowOpen = "_22-c";